import { DataTable } from 'primereact/datatable';
import Heading from '../../../components/Heading/Heading';
import styles from '../../User Management/css/User.module.css';
import { useState, useEffect } from 'react';
import {
	approveTemplateAction,
	generateConsentTemplateDetails,
	generateConsentTemplates,
	removeConsentTemplate,
} from '../../../utils/common.utils';
import CONSTANTS from '../../../constants';
import { Column } from 'primereact/column';
import { getMonthFormatDate, getTimestamp } from '../../../utils/getDate.utils';
import Icon from '../../../components/Icon/Icon';
import { Tooltip } from 'primereact/tooltip';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import TemplateModal from '../../../components/TemplateModal/TemplateModal';

const ApproveTemplate = () => {
	const [templates, setTemplates] = useState([]);
	const [templateDetails, setTemplateDetails] = useState({});

	useEffect(() => {
		generateConsentTemplates(setTemplates);
	}, []);

	const dateTemplate = (rowData, fieldData) => {
		if (!rowData[`${fieldData.field}`]) return <span></span>;
		const convertedTimestamp = getTimestamp(rowData[`${fieldData.field}`]);
		const date = getMonthFormatDate(convertedTimestamp?.split(' ')[0]);
		const time = convertedTimestamp?.split(' ')[1];
		const ampm = convertedTimestamp?.split(' ')[2];
		return <span>{`${date} ${time} ${ampm}`}</span>;
	};

	const handleGetTemplateDetails = (rowData) => {
		generateConsentTemplateDetails(
			rowData.templateName,
			setTemplateDetails,
			templates,
			setTemplates
		);
	};

	const handleDeleteTemplate = (rowData) => {
		removeConsentTemplate(rowData.templateName, setTemplates);
	};

	const handleApproveTemplate = (rowData) => {
		approveTemplateAction(rowData.templateName, setTemplates);
	};

	// console.log(templateDetails);

	const actionBodyTemplate = (rowData) => {
		return (
			<div className={styles['actions__container']}>
				<Icon
					icon="check_circle"
					tooltip={`Approve this consent template action request (${rowData.action})`}
					className={`${styles['actions-icon']} ${styles['table-icon']} approve`}
					onClick={() => handleApproveTemplate(rowData)}
				/>
				<Tooltip target=".approve" position="top" className={styles.tooltip} />
				<Icon
					icon="delete"
					tooltip="Create a delete request"
					className={`${styles['actions-icon']} ${styles['table-icon']} delete`}
					onClick={() => handleDeleteTemplate(rowData)}
				/>
				<Tooltip target=".delete" position="top" className={styles.tooltip} />
				<Button
					className={styles['action-button']}
					onClick={() => handleGetTemplateDetails(rowData)}
				>
					View Details
				</Button>
				<Dialog
					header="Template Details"
					visible={rowData.visible}
					onHide={() => {
						//Change one single object
						const updatedTemplateDetails = {
							...templateDetails,
							visible: false,
						};
						setTemplateDetails(updatedTemplateDetails);

						//Change array of objects to maintain state
						const updatedApprovedTemplateList = templates.map((tempObj) =>
							tempObj.templateName === rowData.templateName
								? updatedTemplateDetails
								: tempObj
						);
						setTemplates(updatedApprovedTemplateList);
					}}
				>
					<TemplateModal templateData={templateDetails} />
				</Dialog>
			</div>
		);
	};
	return (
		<div className="main">
			<Heading>Approve Consent Templates</Heading>
			<div className={styles['user__container']}>
				<div className={styles['table__container']}>
					<DataTable
						value={templates}
						paginator
						rows={20}
						rowsPerPageOptions={[5, 10, 15, 20, 30, 50]}
						emptyMessage="No consent templates found."
						removableSort
					>
						{CONSTANTS.templateColumns.map((col) => (
							<Column
								key={col.field}
								field={col.field}
								header={col.header}
								sortable
							/>
						))}
						<Column
							body={dateTemplate}
							field="creationDate"
							header="Creation Date"
							sortable
						></Column>
						<Column field="action" header="Action" sortable></Column>
						<Column
							body={actionBodyTemplate}
							field="actions"
							header="Template Actions"
						></Column>
					</DataTable>
				</div>
			</div>
		</div>
	);
};

export default ApproveTemplate;
